import { useLocation, Link } from "react-router-dom";
import SEOMeta from "@/components/feature/SEOMeta";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <SEOMeta
        title="页面未找到 - 农民影视"
        description="抱歉，您访问的页面不存在。返回农民影视首页，继续享受免费高清影视在线观看服务。"
      />
      <Navbar />
      <main className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <h1 className="text-8xl md:text-9xl font-heading font-black text-background-200 select-none">
            404
          </h1>
          <div className="relative z-10 -mt-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
              页面未找到
            </h2>
            <p className="text-sm text-foreground-500 mb-2">
              路径：{location.pathname}
            </p>
            <p className="text-sm text-foreground-500 mb-6">
              抱歉，您访问的页面不存在或已被移除
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/"
                className="inline-flex items-center gap-1.5 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-colors text-sm whitespace-nowrap"
              >
                <i className="ri-home-line"></i>
                返回首页
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-1.5 px-6 py-2.5 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-full border border-background-200/70 transition-colors text-sm whitespace-nowrap"
              >
                <i className="ri-information-line"></i>
                关于我们
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}